"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("@/utils/auth");
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var service = _axios.default.create({
  baseURL: _settingMer.default.apiBaseURL,
  timeout: 60000 // 过期时间
});

// request interceptor
service.interceptors.request.use(function (config) {
  // 发送请求之前做的
  var token = !_store.default.getters.token ? sessionStorage.getItem('token') : _store.default.getters.token;
  if (token) {
    config.headers['Authori-zation'] = token;
  }
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params.temp = Date.parse(new Date()) / 1000;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

/**
 * 审批流结果提示。
 * STARTED        - 已进入审批流，商品要等审批通过才会上架
 * FAILED         - 审批服务没连上/发起失败，业务已被卡在待审核，必须让商户知道
 * NOT_CONFIGURED - 没配审批场景，走平台常规审核，不打扰商户
 */
function notifyApprovalResult(headers) {
  if (!headers) return;
  var status = headers['x-approval-status'];
  if (!status || status === 'NOT_CONFIGURED') return;
  var msg = headers['x-approval-message'] || '';
  try {
    msg = decodeURIComponent(msg);
  } catch (e) {
    // 后端编码异常时按原文展示
  }
  if (status === 'STARTED') {
    (0, _elementUi.Message)({
      message: msg || '已提交审批，审批通过后生效',
      type: 'success',
      duration: 4 * 1000
    });
  } else if (status === 'FAILED') {
    (0, _elementUi.Message)({
      message: msg || '审批流程发起失败，请联系平台处理',
      type: 'error',
      duration: 8 * 1000
    });
  }
}

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  // 如果是文件下载请求（blob类型），直接返回响应数据
  if (response.config.responseType === 'blob') {
    return res;
  }

  // if custom code is not 20000, it is judged as an error.
  if (res.code === 401) {
    // to re-login
    // 必须先清掉 cookie 里的 token：路由守卫读的是它，不清的话跳到 /login
    // 会被守卫当成已登录再弹回首页，首页又 401，页面就会无限刷新。
    // 打出是哪个接口把会话判死的，排查时不用一条条点 Network
    console.error('[401] 会话失效，触发接口：', response.config.url, res);
    if (!window.__authRedirecting) {
      window.__authRedirecting = true;
      (0, _auth.removeToken)();
      sessionStorage.removeItem('token');
      window.localStorage.clear();
      _store.default.commit('user/SET_TOKEN', '');
      _elementUi.Message.error('无效的会话，或者登录已过期，请重新登录。');
      if (window.location.pathname !== '/login') location.href = '/login';
    }
    return Promise.reject();
  }

  // 展示性接口（页脚版权、图片域名之类）拿不到数据不该打断用户，
  // 调用方传 silent: true 就只失败不弹窗。
  var silent = response.config && response.config.silent;
  if (res.code !== 200 && res.code !== 401) {
    // 403 原先会弹两次：这里一次，上面 else if 分支还有一次「没有权限访问。」
    // 现在统一在这里弹一条，403 用固定文案，其余用后端返回的 message。
    if (!silent) {
      (0, _elementUi.Message)({
        message: res.code === 403 ? '没有权限访问。' : res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject();
  } else {
    // 审批流提示：后端通过 X-Approval-* 头告知本次操作是否进了审批流。
    // 拦截器只把 res.data 抛给业务代码，header 会被丢掉，所以在这里统一提示。
    notifyApprovalResult(response.headers);
    return res.data;
  }
}, function (error) {
  (0, _elementUi.Message)({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
var _default = exports.default = service;